import React, { useRef, useState, useEffect } from "react";
import Profile from "assets/img/Nav_Icon.ico";
import { useNavigate } from "react-router";

const UserDropdown = () => {
  const [open, setOpen]     = useState(false);
  const dropdownRef         = useRef(null);
  const navigate            = useNavigate();

  /* Close when clicking outside */
  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
    setOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Avatar trigger */}
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="flex items-center gap-2 focus:outline-none"
      >
        <span
          className="w-9 h-9 rounded-full flex items-center justify-center overflow-hidden"
          style={{ border: "2px solid var(--color-border)" }}
        >
          <img
            alt="Profile"
            className="w-full h-full object-cover rounded-full"
            src={Profile}
          />
        </span>
      </button>

      {/* Dropdown menu */}
      {open && (
        <div
          className="absolute right-0 mt-2 w-44 rounded-xl overflow-hidden z-50"
          style={{
            background: "#fff",
            boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
            border: "1px solid var(--color-border)",
          }}
        >
          <div className="px-4 py-3" style={{ borderBottom: "1px solid var(--color-border)" }}>
            <p className="text-xs font-semibold" style={{ color: "var(--color-text-primary)" }}>
              Administrator
            </p>
            <p className="text-xs" style={{ color: "var(--color-text-muted)" }}>
              SRR Enterprise
            </p>
          </div>

          <button
            onClick={handleLogout}
            className="w-full text-left px-4 py-2.5 text-sm flex items-center gap-2 transition-colors hover:bg-slate-50"
            style={{ color: "#EF4444" }}
          >
            <i className="fas fa-sign-out-alt text-xs" />
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
};

export default UserDropdown;
